/**
 * Build-time fallback for the iOS App Store rating on `/wedding-website/`.
 *
 * At build time, `fetchAppStoreRating` fetches the live value from the iTunes lookup API
 * and creates a `WwAppRating` GraphQL node consumed by `wedding-website.tsx`. These
 * hardcoded values are only used if that API call fails.
 *
 * Source: iOS App Store, confirmed 2026-06-16 (4.8 across 8,630 ratings).
 */
export const WW_APP_RATING = {
  ratingValue: 4.8,
  ratingCount: 8630,
} as const;

/** Confirmed store listings for the Joy app — used as `sameAs` on the SoftwareApplication. */
export const WW_APP_STORE_URLS = [
  'https://apps.apple.com/us/app/joy-wedding-planner-website/id994411720',
  'https://play.google.com/store/apps/details?id=com.withjoy.joy',
] as const;
